import React from "react";
import PropTypes from "prop-types";
import { CaptionText } from "@components/Text";
import Div from "@components/Div";

const Steps = ({ activeIndex, content }) => {
  return (
    <ul className="progressbar-steps">
      {content.map((step, i) => {
        const { label = "" } = step;
        return (
          <li
            className={
              activeIndex === i ? "active" : activeIndex > i ? "completed" : ""
            }
            key={i}
          >
            <Div
              pt={[0, 0, 0, "var(--lh-micro)"]}
              minWidth={[100, 100, 100, 140]}
            >
              <CaptionText display={["none", "none", "none", "flex"]}>
                {label}
              </CaptionText>
            </Div>
          </li>
        );
      })}
    </ul>
  );
};
Steps.propTypes = {
  activeIndex: PropTypes.number,
  content: PropTypes.array,
};
export default Steps;
